import BaseModel from './BaseModel';

export default class Stock extends BaseModel {
  constructor({id, number, designation, projectPart = undefined}) {
    super(id, number, designation);
    this.projectPart = projectPart;
  }

  static get config() {
    const baseConfig = {...BaseModel.config};
    baseConfig['addable'] = false;
    return baseConfig;
  }

  static get fkName() {
    return 'stock_id';
  }
  static get apiRoute() {
    return 'stock';
  }
  static get detailPageRoute() {
    return 'stockList';
  }
  static get listPageRoute() {
    return 'stockList';
  }
  get fkName() {
    return Stock.fkName;
  }
  get apiRoute() {
    return Stock.apiRoute;
  }
  get listPageRoute() {
    return Stock.listPageRoute;
  }
  get detailPageRoute() {
    return Stock.detailPageRoute;
  }

  static get joinAttrsKey() {
    return ['number', 'designation'];
  }

  static get listDisplayAttrs() {
    return this.getAttributes(['number', 'designation']);
  }

  static get browserDisplayAttrs() {
    return this.getAttributes(['number', 'designation']);
  }

  static get allAttributes() {
    return [this.NUMBER_ATTRIBUTE(), this.DESIGNATION_ATTRIBUTE()];
  }
}
